import React, {useEffect, useMemo, useState} from "react";
import {cmpClassName} from "../../../common/generic-react.functions.js";
import Icon from "../icon/icon.component.js";
import {IconButtonContainer} from "./icon-button.styles.js";
function IconButton({
  children,
  dataCy,
  color = "primary",
  disabled,
  size = "medium",
  type = "button",
  onClick
}) {
  const [mainContent, setMainContent] = useState(children);
  const [ariaLabel, setAriaLabel] = useState("button");
  const _dataCy = useMemo(() => dataCy || children, [children, dataCy]);
  useEffect(() => {
    if (children && typeof children === "string") {
      setMainContent(/* @__PURE__ */ React.createElement(Icon, null, children));
      setAriaLabel(children);
    } else {
      setMainContent(children);
      setAriaLabel("button");
    }
  }, [children, dataCy]);
  return /* @__PURE__ */ React.createElement(IconButtonContainer, {
    "data-cy": _dataCy,
    className: cmpClassName("icon-button"),
    color,
    disabled,
    size,
    type,
    onClick,
    "aria-label": ariaLabel
  }, mainContent);
}
export default /* @__PURE__ */ React.memo(IconButton);
